/******
 *
 * formulas used
 *revenue growth y/y=((current year revenue -previous year revenue)/previous year total revenue)*100
 * operating expense y/y=((current year opEx -previous year opEx)/previous year total opEx)*100
 * using income details
 */

import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  mode: "dark",
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontFamily: "public sans",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    fontFamily: "public sans",
  },
}));

const EarningsPerShareChart = ({
  incomeDetails,
  mode,
  financialPeriod,
  reportedFinancials,
  isComparing,
}) => {
  const [dataView, setDataView] = useState(false);
  const [growthData, setGrowthData] = useState();
  const [timePeriods, setTP] = useState([]);
  const [basicEPS, setBEPS] = useState([]);
  const [dilutedEPS, setDEPS] = useState([]);
  const [AllCompNetInc, setAllCompNetInc] = useState([]);

  useEffect(() => {
    if (!isComparing) {
      // console.log("reportedFinancials", reportedFinancials);
      if (financialPeriod == "quarterly") {
        if (reportedFinancials?.quarterly?.length > 0) {
          // // console.log("income details", incomeDetails?.quarterly);
          // console.log("trueeeeeeeeeeeee");
          let repFin = reportedFinancials?.quarterly;

          // console.log(
          //   "2006-2007 difference",
          //   ((incDet[14]?.totalRevenue - incDet[15]?.totalRevenue) /
          //     incDet[16 - 1]?.totalRevenue) *
          //     100
          // );
          let temp = [];
          let i = repFin?.length - 1;
          // console.log("rep", repFin);
          while (i >= 0) {
            // console.log("i", i, repFin[i]?.fiscalYear, repFin[i]?.fiscalQuarter);
            // console.log(
            //   "i",
            //   i,
            //   repFin[i]?.formFiscalQuarter,
            //   repFin[i]?.formFiscalYear
            // );
            // console.log(
            //   "i",
            //   i,
            //   repFin[i]?.DocumentFiscalYearFocus,
            //   repFin[i]?.DocumentFiscalPeriodFocus
            // );
            if (
              repFin[i]?.EarningsPerShareDiluted ||
              repFin[i]?.EarningsPerShareBasicAndDiluted
            ) {
              temp.push({
                fiscalPeriod: repFin[i]?.DocumentFiscalPeriodFocus
                  ? `FY${repFin[i]?.DocumentFiscalYearFocus - 2000} ${
                      repFin[i]?.DocumentFiscalPeriodFocus
                    }`
                  : repFin[i]?.fiscalQuarter
                  ? `FY${repFin[i]?.fiscalYear - 2000} Q${
                      repFin[i]?.fiscalQuarter
                    }`
                  : repFin[i]?.formFiscalYear
                  ? `FY${repFin[i]?.formFiscalYear - 2000} Q${
                      repFin[i]?.formFiscalQuarter
                    }`
                  : `FY Q `,

                basicEPS: repFin[i]?.EarningsPerShareBasic
                  ? repFin[i]?.EarningsPerShareBasic
                  : repFin[i]?.EarningsPerShareBasicAndDiluted,
                dilutedEPS: repFin[i]?.EarningsPerShareDiluted
                  ? repFin[i]?.EarningsPerShareDiluted
                  : repFin[i]?.EarningsPerShareBasicAndDiluted,
              });
            }

            i = i - 1;
          }
          // console.log("lat Arr", temp);

          setTP(temp.map((t) => t?.fiscalPeriod));
          setBEPS(temp.map((t) => t?.basicEPS?.toFixed(2)));
          setDEPS(temp.map((t) => t?.dilutedEPS?.toFixed(2)));

          // // console.log("data>", temp);
          setGrowthData(temp);
        }
      } else {
        if (reportedFinancials?.annual?.length > 0) {
          // console.log("details", reportedFinancials?.annual);
          // console.log("trueeeeeeeeeeeee");
          let repFin = reportedFinancials?.annual;

          // console.log(
          //   "2006-2007 difference",
          //   ((repFin[14]?.totalRevenue - repFin[15]?.totalRevenue) /
          //     repFin[16 - 1]?.totalRevenue) *
          //     100
          // );
          let temp = [];
          let i = repFin?.length - 1;
          while (i >= 0) {
            // console.log("i", i, repFin[i]?.fiscalYear, repFin[i - 1]?.fiscalYear);
            if (
              repFin[i]?.EarningsPerShareDiluted ||
              repFin[i]?.EarningsPerShareBasicAndDiluted
            ) {
              temp.push({
                fiscalPeriod: repFin[i]?.DocumentFiscalYearFocus
                  ? `${repFin[i]?.DocumentFiscalYearFocus} `
                  : repFin[i]?.fiscalYear
                  ? `${repFin[i]?.fiscalYear}`
                  : `${repFin[i]?.formFiscalYear} `,
                basicEPS: repFin[i]?.EarningsPerShareBasic
                  ? repFin[i]?.EarningsPerShareBasic
                  : repFin[i]?.EarningsPerShareBasicAndDiluted,
                dilutedEPS: repFin[i]?.EarningsPerShareDiluted
                  ? repFin[i]?.EarningsPerShareDiluted
                  : repFin[i]?.EarningsPerShareBasicAndDiluted,
              });
            }

            i = i - 1;
          }
          // console.log("lat Arr", temp);

          setTP(temp.map((t) => t?.fiscalPeriod));
          setBEPS(temp.map((t) => t?.basicEPS?.toFixed(2)));
          setDEPS(temp.map((t) => t?.dilutedEPS?.toFixed(2)));

          // // console.log("data>", temp);
          setGrowthData(temp);
        }
      }
    }

    // console.log("changed", financialPeriod, incomeDetails);
  }, [reportedFinancials, financialPeriod]);
  /*********** while comparing */
  useEffect(() => {
    console.log("reported financials in eps chart", reportedFinancials);
    if (isComparing && reportedFinancials?.length > 0) {
      console.log(
        "reported Financials details",
        financialPeriod,
        reportedFinancials
      );
      if (financialPeriod == "quarterly") {
        setTP(reportedFinancials.map((t) => t?.financialPeriod));
        let symbols = reportedFinancials[0]?.earningsPerShare?.map(
          (shares) => shares?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return reportedFinancials?.map((i) => {
            return i?.earningsPerShare[ind]?.eps;
          });
        });
        console.log("series", series);
        setAllCompNetInc(series);
      } else {
        setTP(reportedFinancials.map((t) => t?.financialPeriod));

        let symbols = reportedFinancials[0]?.earningsPerShare?.map(
          (shares) => shares?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return reportedFinancials?.map((i) => {
            return i?.earningsPerShare[ind]?.eps;
          });
        });
        console.log("series", series);
        setAllCompNetInc(series);
      }
    }
  }, [reportedFinancials, financialPeriod]);

  var options = {
    series: !isComparing
      ? [
          {
            name: "Basic EPS",
            data: basicEPS,
          },
          {
            name: "Diluted EPS",
            data: dilutedEPS,
          },
        ]
      : AllCompNetInc?.length > 0
      ? reportedFinancials[0]?.earningsPerShare?.map((inc, i) => {
          return { name: inc?.symbol, data: AllCompNetInc[i] };
        })
      : [],
    chart: {
      type: "line",
      height: 1400,
      background: "transparent",
      toolbar: {
        show: true,

        tools: {
          download: true,
          selection: window?.screen?.width > 600 ? true : false,
          zoom: window?.screen?.width > 600 ? true : false,
          zoomin: window?.screen?.width > 600 ? true : false,
          zoomout: window?.screen?.width > 600 ? true : false,
          pan: window?.screen?.width > 600 ? true : false,
          reset: window?.screen?.width > 600 ? true : false,
        },
        export: {
          csv: {
            filename: financialPeriod + " -EPS",
            columnDelimiter: ",",
            headerCategory: "Financial Period",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: financialPeriod + " -EPS",
          },
          png: {
            filename: financialPeriod + " -EPS",
          },
        },
      },
    },
    colors: ["#ec544c", "#2d79db", "#CA955C", "#fcc432", "#985ceb"],

    stroke: {
      curve: "smooth",
      width: window?.screen?.width > 600 ? 5 : 3,
      lineCap: "butt",
      colors: ["#ec544c", "#2d79db", "#CA955C", "#fcc432", "#985ceb"],
      // OR provide an array
      // curve: ["smooth", "straight", "stepline"],
    },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: "75%",
    //       endingShape: "rounded",
    //     },
    //   },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ["transparent"],
    // },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "top",
      horizontalAlign: "center",
      floating: false,
      fontSize: window?.screen?.width > 600 ? "14px" : "10px",
      fontFamily: "public sans",
      fontWeight: 400,
      labels: {
        useSeriesColors: true,
      },

      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    grid: {
      show: true,
      borderColor: mode == "light" ? "#d9d9d999" : "#d9d9d955",
      row: {},
      xaxis: {
        lines: {
          show: false,
        },
        position: "top",
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    theme: {
      mode: mode,
      //   palette: "palette5",
    },
    xaxis: {
      lines: {
        show: false, //or just here to disable only y axis
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      // axisBorder: {
      //   show: true,
      //   color: "#78909C",
      //   height: 1,
      //   width: "100%",
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      // axisTicks: {
      //   show: true,
      //   borderType: "solid",
      //   color: "#78909C",
      //   height: 6,
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      categories: timePeriods,
      labels: {
        show: true,
        rotate: -50,
        rotateAlways: window?.screen?.width > 768 ? false : true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        maxHeight: 120,
        style: {
          color: new Array(timePeriods?.length)?.fill("#ff0000"),
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      tickAmount: 10,
      title: {
        text: "",
      },
      labels: {
        formatter: function (value) {
          return numFormatter(value.toFixed(2)) + "  ";
        },
        style: {
          colors: [],
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return numFormatter(val) + "";
        },
      },
    },
  };

  //   var options = {
  //     series: [
  //       {
  //         name: "Revenues",
  //         data: revenues,
  //       },
  //       {
  //         name: "Operating Incomes",
  //         data: operatingIncomes,
  //       },
  //       {
  //         name: "Gross Profit",
  //         data: grossProfit,
  //       },
  //     ],
  //     chart: {
  //       height: 350,
  //       type: "line",
  //       zoom: {
  //         enabled: false,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     stroke: {
  //       curve: "straight",
  //     },
  //     title: {
  //       text: "Product Trends by Month",
  //       align: "left",
  //     },
  //     grid: {
  //       row: {
  //         colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
  //         opacity: 0.5,
  //       },
  //     },
  //     xaxis: {
  //       categories: timePeriods,
  //     },
  //   };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontFamily: "public sans",
      fontWeight: 300,
    },
  }));

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 300,
      fontFamily: "public sans",
    },
  }));
  const [chartDescription, x] = useState(
    "Earnings per share is a company's net income, minus cumulative preferred dividends, divided by the number of common outstanding shares. Diluted earnings per share represent the company's net income minus preferred dividends, divided by the total of the weighted average number of shares and other dilutive securities."
  );
  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        Earnings Per Share
      </Box>
      {dataView ? (
        <Box
          sx={{
            minWidth: "300px",
            marginLeft: "50%",
            transform: "translateX(-50%)",
          }}
          onClick={() => console.log("option.series", options?.series)}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 50,
                fontFamily: "public sans",
              }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead
                sx={{
                  backgroundColor: "bgSecondary.main",
                  color: "fontSecondaryColor.main",
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "bgSecondary.main",
                  }}
                >
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                  >
                    Financial Period
                  </StyledTableCell>
                  {options?.series?.length > 0 &&
                    options?.series?.map((ser) => (
                      <StyledTableCell
                        sx={{
                          color: "fontPrimaryColor.main",
                          textAlign: "right",
                        }}
                      >
                        {ser?.name}
                      </StyledTableCell>
                    ))}
                  {/* <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    EPS Basic
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    EPS Diluted
                  </StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {new Array(timePeriods?.length).fill("1").map((row, i) => (
                  <TableRow
                    key={timePeriods[i]}
                    sx={{
                      backgroundColor: "bgPrimary.main",
                      boxShadow:
                        mode == "dark"
                          ? "#888 0px 0px 0px 1px"
                          : "#e6e6e6 0px 0px 0px 1px",
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      component="th"
                      scope="row"
                    >
                      {timePeriods[i]}
                    </StyledTableCell>
                    {options?.series?.length > 0 &&
                      options?.series?.map((ser) => (
                        <StyledTableCell
                          sx={{
                            color: "fontSecondaryColor.main",
                            borderBottom: "none",
                          }}
                          align="right"
                        >
                          {numFormatter(ser?.data && ser?.data[i])}
                        </StyledTableCell>
                      ))}
                    {/* <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {numFormatter(options?.series[0]?.data[i])}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {" "}
                      {numFormatter(options?.series[1]?.data[i])}
                    </StyledTableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : isComparing ? (
        <>
          {reportedFinancials?.length > 0 && (
            <Chart
              options={options}
              series={options?.series}
              type="line"
              height={window?.screen?.width > 600 ? "200%" : "150%"}
              width="100%"
            />
          )}
        </>
      ) : (
        <Chart
          options={options}
          series={options?.series}
          type="line"
          height={window?.screen?.width > 600 ? "200%" : "150%"}
          width="100%"
        />
      )}

      <Box className="chart__bottom__options__bar" sx={{ gap: "10px" }}>
        <Box
          className="showChartInfoBtn"
          sx={{ backgroundColor: "bgSecondary.main", borderRadius: "50%" }}
        >
          {mode == "dark" ? (
            <LightTooltip title={chartDescription} arrow>
              <Box>
                <QuestionMarkIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </Box>
            </LightTooltip>
          ) : (
            <BootstrapTooltip title={chartDescription} arrow>
              <QuestionMarkIcon
                sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
              />
            </BootstrapTooltip>
          )}
        </Box>
        <Box onClick={() => setDataView(!dataView)}>
          <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
            <ViewListIcon
              sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
            />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default EarningsPerShareChart;
function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}
